import React, { useEffect, useState } from 'react'
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
    Select, Button, Input, useToast
} from '@chakra-ui/react'
import { useTestsStore } from '../../store/testsStore'
import { isValidUrl, toastError, toastSuccess } from '../../utils/globalHelper'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import TestsService from '../../API/TestsService'
import { useGlobalStore } from '../../store/globalStore'
import { useStudentsStore } from '../../store/studentsStore'

function TestModal({isOpen, onClose, title, test}) {
    const toast = useToast()
    const students = useStudentsStore(state => state.students)
    const [user, subjects] = useGlobalStore(state => [state.user, state.subjects])
    const [tests, setTests] = useTestsStore(state => [state.tests, state.setTests])
    const [disableSave, setDisableSave] = useState(test ? false : true)
    const [state, setState] = useState(test ? test : {
        date: '',
        student_id: 0,
        creator_id: user.id,
        subject_id: 0,
        status_id: 2,
        link: '',
        note: ''
    })
    const createTest = useAccessAPI(TestsService.createTest)
    const updateTest = useAccessAPI(TestsService.updateTest)

    const checkSaveEnable = (newState) => {
        setDisableSave(
            newState.student_id === 0 || !newState.date || !isValidUrl(newState.link)
        )
    }

    const onBtnSave = async () => {
        if (test) {
            const response = await updateTest(test.id, state)
            if (response?.status === 200) {
                setTests(tests.map(el => {
                    if (el.id === test.id)
                        return response.data
                    return el
                }))
                toast(toastSuccess("Зачёт изменён"))
            } else {
                toast(toastError('Ошибка при изменении зачёта'))
            }
        }
        else {
            const response = await createTest({...state, title: 'Какой тайтл?'})
            if (response?.status === 200) {
                setTests([...tests, response.data])
                toast(toastSuccess("Зачёт добавлен"))
            } else {
                toast(toastError('Ошибка при добавлении зачёта'))
            }
        }

        onCloseBtn()
    }

    const onCloseBtn = () => {
        setState(test ? test : {
            date: '',
            student_id: 0,
            creator_id: user.id,
            subject_id: 0,
            status_id: 2,
            link: '',
            note: ''
        })
        onClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={onCloseBtn}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{title}</ModalHeader>
                <ModalCloseButton />
                <ModalBody display='grid' gap='var(--default-gap)'>
                    <Select
                        placeholder='Выберите ученика'
                        value={state.student_id}
                        onChange={event => {
                            setState({...state, student_id: Number(event.target.value)})
                            checkSaveEnable({...state, student_id: Number(event.target.value)})
                        }}
                    >
                        {students.map((student) => (
                            <option
                                value={student.id}
                                key={`teststud${student.id}`}
                            >
                                {`${student.last_name} ${student.first_name}`}
                            </option>
                        ))}
                    </Select>
                    <Input
                        placeholder='Дата зачета'
                        type='datetime-local'
                        value={state.date}
                        onChange={event => {
                            setState({...state, date: event.target.value})
                            checkSaveEnable({...state, date: event.target.value})
                        }}
                    />
                    <Select
                        placeholder='Выберите предмет'
                        value={state.subject_id}
                        onChange={event => setState({...state, subject_id: Number(event.target.value)})}
                    >
                        {subjects.map((subject) => (
                            <option
                                value={subject.id}
                                key={`testsubject${subject.id}`}
                            >
                                {subject.title}
                            </option>
                        ))}
                    </Select>
                    <Select 
                        value={state.status_id}
                        onChange={event => setState({...state, status_id: Number(event.target.value)})}
                    >
                        <option value={1}>Сдан</option>
                        <option value={2}>Не сдан</option>
                    </Select>
                    <Input 
                        type='url'
                        placeholder='Ссылка на зачет'
                        value={state.link}
                        onChange={event => {
                            setState({...state, link: event.target.value})
                            checkSaveEnable({...state, link: event.target.value})
                        }}
                    />
                    <Input 
                        placeholder='Примечания'
                        value={state.note}
                        onChange={event => setState({...state, note: event.target.value})}
                    />
                </ModalBody>

                <ModalFooter>
                    <Button onClick={onCloseBtn} mr="var(--default-gap)" variant='secondary'>
                        Отмена
                    </Button>
                    <Button
                        isDisabled={disableSave}
                        onClick={onBtnSave}
                    >
                        {test ? 'Сохранить' : 'Добавить'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default TestModal
